import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ReferralAgreementsPage from 'components/Invoicing/Referral/Agreement/ReferralAgreementsPage';

const ReferralInvoicingRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        component={ReferralAgreementsPage}
        exact
        path={path}
      />
    </Switch>
  );
};

export default ReferralInvoicingRoute;